import { inject, Injectable } from '@angular/core';

import { PositionsDialogsOpener } from '@core/tellent-positions-contracts';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { PositionDetailsDialogComponent } from '../position-details-dialog/position-details-dialog.component';

@Injectable()
export class PositionsDialogsService implements PositionsDialogsOpener {
  private readonly dialog = inject(DialogService);

  public openPositionDetails(positionGuid: string): void {
    this.dialog.openCustom(
      PositionDetailsDialogComponent,
      { width: DialogWidth.Medium },
      { positionGuid },
    );
  }
}
